async function checkPermission(): Promise<void> {
  // firefox doesn't comply with the 'clipboard-write' permission
  if (!navigator.permissions || /firefox/i.test(navigator.userAgent)) {
    return;
  }

  // lib.dom.d.ts isn't up-to-date with the permissions enum
  const result = await navigator.permissions.query({
    name: "clipboard-write" as any,
  });
  if ("denied" == result.state) {
    throw new Error("clipboard-write permission denied");
  }
}

export async function writeClipboard(data: string): Promise<void> {
  await checkPermission();
  await navigator.clipboard.writeText(data);
}
